function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import FormBuilder from '../../Pieces/FormElements/_FormBuilder';
export default {
  name: 'TriggerMap',
  props: ['trigger', 'provider_info'],
  components: {
    FormBuilder: FormBuilder
  },
  data: function data() {
    return {
      settings_fields: {},
      loading: false
    };
  },
  methods: {
    triggerEventChanged: function triggerEventChanged() {
      if (!this.trigger.trigger_name) {
        this.trigger.settings = {};
        return false;
      }
      var selectedTrigger = JSON.parse(JSON.stringify(this.provider_info.triggers[this.trigger.trigger_name]));
      this.trigger.settings = selectedTrigger.settings_defaults;
      this.trigger.title = selectedTrigger.title;
      this.fetchSettingsFields();
    },
    fetchSettingsFields: function fetchSettingsFields() {
      var _this = this;
      this.loading = true;
      this.$get('feeds/trigger_fields', _objectSpread({}, this.trigger)).then(function (response) {
        _this.settings_fields = response.settings_fields;
      })["catch"](function (errors) {
        _this.$handleError(errors);
      }).always(function () {
        _this.loading = false;
      });
    },
    emitSave: function emitSave() {
      this.trigger.is_open = !this.trigger.is_open;
      this.$emit('update');
    }
  },
  mounted: function mounted() {
    if (this.trigger.trigger_name) {
      this.fetchSettingsFields();
    }
  }
};